import { StoreContext } from 'models/import';
import { useContext, useEffect } from 'react';
import PartnersComponent from './partners';

function PartnersProComponent() {
  const { setIsProPage } = useContext(StoreContext);

  useEffect(() => {
    setIsProPage(true);

    return () => {
      setIsProPage(undefined);
    };
  }, []);

  return (
    <PartnersComponent />
  );
}

export default PartnersProComponent;
